export default [
  {
    hid: 'og:image',
    name: 'og:image',
    property: 'og:image',
    content: 'https://campsite.bio/og-open-graph2.jpg',
  },
  {
    hid: 'og:image:height',
    name: 'og:image:height',
    property: 'og:image:height',
    content: '630',
  },
  {
    hid: 'og:image:width',
    name: 'og:image:width',
    property: 'og:image:width',
    content: '1200',
  },
  {
    hid: 'twitter:image',
    name: 'twitter:image',
    content: 'https://campsite.bio/og-open-graph2.jpg',
  },
  {
    property: 'og:site_name',
    content: 'Campsite.bio',
  },
  {
    name: 'twitter:domain',
    content: 'Campsite.bio',
  },
  {
    name: 'twitter:card',
    content: 'summary',
  },
];
